
import DatePicker from "@/core/components/DatePicker.vue";
import { VSelectItem } from "@/core/interfaces/v-select.interface";
import { DoctorCategoriesReference } from "@/core/references/doctor-categories";
import { DoctorEducationsReference } from "@/core/references/doctor-educations";
import { ScientificDegreesReference } from "@/core/references/scientific-degrees";
import { Profile, ProfileSpecialization } from "@/modules/cabinet/profile.interface";
import { SpecializationsReference } from "@/core/references/specializations";
import { UniversitiesReference } from "@/core/references/universities";
import jsonToFormData from "@ajoelp/json-to-formdata";
import Vue, { PropType } from "vue";

export default Vue.extend({
  name: "DetailData",
  components: { DatePicker },
  props: {
    profile: {
      type: Object as PropType<Profile>,
      required: true,
    },
  },

  data() {
    return {
      addUniversityForm: {
        name: "",
        finish_date: null,
      },
      specializations: [] as VSelectItem[],
      selectedSpecialization: null as VSelectItem | null,
      specializationsLoading: false,
      universities: [] as VSelectItem[],
      selectedUniversity: null as VSelectItem | null,
      universitiesLoading: false,
      categories: [] as VSelectItem[],
      scientificDegrees: [] as VSelectItem[],
      educations: [] as VSelectItem[],
      form: {
        specializations: this.profile.specializations,
        universities: this.profile.universities,
        doctor_category: this.profile.doctor_category,
        license_number: this.profile.license_number,
        license_date: this.profile.license_date,
        short_description: this.profile.short_description,
        long_description: this.profile.long_description,
        scientific_degree: this.profile.scientific_degree,
        education: this.profile.education,
        files: [] as File[],
      },
      formError: "",
    };
  },

  async created(): Promise<void> {
    await this.loadReferences();
  },
  computed: {
    allowEditSchedule(): boolean {
      return this.$store.state.auth.profile.schedule_editor_flag || this.$store.state.auth.profile.own_schedule_editor_flag;
    },
  },
  methods: {
    async loadReferences() {
      const [categories, scientificDegrees, educations] = await Promise.all([
        this.$registry.get(DoctorCategoriesReference).getSelectItems(),
        this.$registry.get(ScientificDegreesReference).getSelectItems(),
        this.$registry.get(DoctorEducationsReference).getSelectItems(),
      ]);

      this.categories = categories;
      this.scientificDegrees = scientificDegrees;
      this.educations = educations;
    },

    removeFormReferenceItem(filed: string, item: { id: number }): void {
      this.form[filed] = this.form[filed].filter((fieldItem: { id: number }) => fieldItem.id !== item.id);
    },

    async findSpecialization(query: string) {
      if (!query || query.length < 2) {
        return;
      }

      await this.$registry.get(SpecializationsReference).getList(query);
      this.specializations = this.$registry.get(SpecializationsReference).getDoctorSelectItems();
    },

    addSpecialization(): void {
      if (!this.selectedSpecialization) {
        (this.$refs.specializationsFiled as HTMLElement).focus();
        return;
      }

      this.form.specializations.push({
        id: this.selectedSpecialization.value as number,
        name: this.selectedSpecialization.text as string,
      });
      this.selectedSpecialization = null;
    },

    async findUniversity(query: string) {
      if (!query || query.length < 2) {
        return;
      }

      await this.$registry.get(UniversitiesReference).getList(query);
      this.universities = this.$registry.get(UniversitiesReference).getSelectItems();
    },

    addUniversity(): void {
      if (!this.selectedUniversity) {
        (this.$refs.universitiesField as HTMLElement).focus();
        return;
      }

      this.form.universities.push({
        id: this.selectedUniversity.value as number,
        name: this.selectedUniversity.text as string,
        finish_date: "",
      });
      this.selectedUniversity = null;
    },

    // async openAttachFile(item: FileML) {},

    async onSubmit(): Promise<void> {
      this.formError = "";
      try {
        const { data } = await this.$http.post(
          "v1/mis/profile/update/additional",
          jsonToFormData({
            ...this.form,
            specializations: this.form.specializations.map((s: ProfileSpecialization) => s.id),
          }),
        );
        console.log("submit", data);
        this.$notify.showMessage("Доктор сохранён", "success");
      } catch (e) {
        console.log(e.response);
        this.$notify.showMessage("Ошибка отправки данных доктора", "error");
        this.formError = "Ошибка отправки данных профиля";
      }
    },
  },
});
